import SeoHelmet from '../SEOHelmet/SeoHelmet'
import './error.css'

function Error() {
    return (
        <div className="w3l-error-grid py-5 text-center">
            <SeoHelmet pageName='Error' />
            <div className="container py-lg-5 py-md-4">
                <div className="center-align">
                    <h1>404</h1>
                    <h2>Page not found</h2>
                    <p>We are very sorry for the inconvinience. Its look like you're trying to acces a page that has been
        deleted or never even existed.</p>
                    {/* <form className="form-inline search-form mt-md-5 mt-4" action="#" method="post">
                        <input className="form-control" type="search" placeholder="Search here" aria-label="email" required />
                        <button className="btn search" type="submit">Submit</button>
                    </form> */}
                    <div className="mt-5">
                        <a href="/" className="btn-small"> Back to home</a>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Error
